export default __webpack_public_path__ + "static/media/problem.351be77d.png";